// Sección de segmentos en Admin

import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const SegmentosAdmin = () => {
    const [segmentos, setSegmentos] = useState([]);
    const [newSegmento, setNewSegmento] = useState("");

    useEffect(() => {
        fetchSegmentos();
    }, []);

    const fetchSegmentos = async () => {
        try {
            const res = await fetch(`${BASE}/buscar_segmentos.php`);
            const data = await res.json();
            setSegmentos(data);
        } catch {
            toast.error("Error al cargar segmentos");
        }
    };

    const handleAdd = async () => {
        const nombre = newSegmento.trim();
        if (!nombre) return;
        try {
            const res = await fetch(`${BASE}/guardar_segmento.php`, {
                method: "POST",
                body: new URLSearchParams({ nombre }),
            });
            const data = await res.json();
            if (data.ok) {
                toast.success("Segmento agregado");
                setNewSegmento("");
                fetchSegmentos();
            } else {
                toast.error(data.error || "Error al agregar");
            }
        } catch {
            toast.error("Error de conexión");
        }
    };

    const handleEdit = async (seg) => {
        const newName = prompt("Nuevo nombre para el segmento:", seg.nombre);
        if (!newName || newName.trim() === seg.nombre) return;
        try {
            const res = await fetch(`${BASE}/editar_segmento.php`, {
                method: "POST",
                body: new URLSearchParams({ id: seg.id, oldName: seg.nombre, newName: newName.trim() }),
            });
            const data = await res.json();
            if (data.ok) {
                toast.success("Segmento actualizado (y cascadeado en clientes)");
                fetchSegmentos();
            } else {
                toast.error(data.error || "Error al editar");
            }
        } catch {
            toast.error("Error de conexión");
        }
    };

    const handleDelete = async (seg) => {
        if (!window.confirm(`¿Eliminar el segmento "${seg.nombre}"?`)) return;
        try {
            const res = await fetch(`${BASE}/eliminar_segmento.php`, {
                method: "POST",
                body: new URLSearchParams({ id: seg.id }),
            });
            const data = await res.json();
            if (data.ok) {
                toast.success("Segmento eliminado");
                fetchSegmentos();
            } else {
                toast.error(data.error || "Error al eliminar");
            }
        } catch {
            toast.error("Error de conexión");
        }
    };

    return (
        <section>
            <div className="container">
                <div className="container-addbar" style={{ marginTop: "40px" }}>
                    <input
                        type="text"
                        value={newSegmento}
                        onChange={(e) => setNewSegmento(e.target.value)}
                        placeholder="Nuevo Segmento"
                        onKeyDown={(e) => e.key === "Enter" && handleAdd()}
                    />
                    <button className="searchbar_form_submit" onClick={handleAdd}>
                        Agregar
                    </button>
                </div>

                <div className="categories-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Segmento</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {segmentos.map((seg) => (
                            <tr key={seg.id}>
                                <td>{seg.id}</td>
                                <td>{seg.nombre}</td>
                                <td>
                                    <div style={{ display: "flex", gap: "1px" }}>
                                        <FaRegEdit
                                            className="action-icon"
                                            onClick={() => handleEdit(seg)}
                                            style={{
                                                display: "flex", justifyContent: "center", alignItems: "center",
                                                width: "32px", height: "32px", backgroundColor: "#4893e9",
                                                borderRadius: "5px", cursor: "pointer", marginRight: "7px",
                                            }}
                                        />
                                        <MdDelete
                                            className="action-icon"
                                            onClick={() => handleDelete(seg)}
                                            style={{
                                                display: "flex", justifyContent: "center", alignItems: "center",
                                                width: "32px", height: "32px", backgroundColor: "#D9534F",
                                                borderRadius: "5px", cursor: "pointer",
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </div>
            </div>
        </section>
    );
};

export default SegmentosAdmin;
